import styled from '@emotion/styled';

export const Section = styled.section`
	scroll-margin-top: calc(${(props) => props.theme.heights.header} + 2rem);

	@media screen and (max-width: 1180px) {
		scroll-margin-top: calc(${(props) => props.theme.heights.headerMobile} + 2rem);
	}

	& + & {
		border-top: 1px solid ${(props) => props.theme.ui.border.default};
	}
`;
